export default {
  dbi_filter_modal_tips: 'Tips',
  dbi_filter_modal_ok: 'OK',
  dbi_filter_modal_cancel: 'Cancel',
  dbi_filter_modal_no_longer_prompt: 'No longer prompt',
  dbi_filter_modal_content:
    'Some of the metrics you selected are not available under the current time/country filter granularity. If you want to view the data, please refer to the data source description and switch to the valid time/country granularity for the metrics. If you click "cancel" would back to  previous time and region filters.',
};
